import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { azureQueryKeys } from 'queries/azure/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

type AzureMetadataAuthorizationResponse = {
  deploymentTemplateUrl: string | null
}

function fetchAzureMetadataAuthorization({
  queryKey
}: QueryFunctionContext<
  ReturnType<typeof azureQueryKeys.getMetadataAuthorization>
>) {
  return fetchQueryData<AzureMetadataAuthorizationResponse>(
    getEndpointWithParams(...queryKey)
  )
}

export function useGetAzureMetadataAuthorization(
  options?: Omit<
    UseQueryOptions<AzureMetadataAuthorizationResponse, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()

  return useQuery({
    ...options,
    queryKey: azureQueryKeys.getMetadataAuthorization(currentTeamId),
    queryFn: fetchAzureMetadataAuthorization
  })
}
